import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import { useEffect, useState } from "react"
import { useScrollLock } from "../../../hooks/useScrollLock"
import Button from "../../shared/button/Btn"
import styled from "styled-components"
import PageTopTitle from "../../shared/PageTopTitle"
import InputSelect from "../../shared/input/new/InputSelect"
import {clearJobListWithoutGunlukAraclar, devamliAracUpdate, setUpdatedDevamliArac} from "../../../features/joblist/jobListSlice"

import { handleActiveSelect } from "../../../features/layout/layoutSlice"


const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 900px;
        max-height: 700px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-block: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
        overflow: auto;
        .error{
            font-size: 12px;
            color: var(--color-main);
            margin-top: 5px;
        }
        .inputs{
            padding: 10px 0px;
            width: 60%;
            .row{
                margin-block: 15px;
                
            }
            .btn{
                width: 100%;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                gap: 15px;
                button{
                    padding: 10px;
                }
            }
            
        }
    }


@media (max-width: 850px){
    .modal{
        width: 100% !important;
        .inputs{
            width: 100% !important;
            padding-inline: 20px;
        }
        .btn{
            flex-direction: column;
            align-items: center;
        }
    }
}
`



const UpdateDevamliAracModal = () => {

    const BoolData = [
        {
            id:1,
            text:"Evet",
            bool:true,
        },
        {
            id:2,
            text:"Hayır",
            bool:false
        }
    ]

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

    const {selectedDevamliArac} = useSelector((state) => state.jobList)
    
    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleChangeContinue = (data) => {
        dispatch(setUpdatedDevamliArac({isContinueVehicle: data}))
    }

    const handleChangeReference = (data) => {
        dispatch(setUpdatedDevamliArac({isReferenceDriver: data}))
    }

    const handleSave = () => {
        const saveData = {
            id: selectedDevamliArac.id ,
            "isContinueVehicle": selectedDevamliArac?.isContinueVehicle, 
            "isReferenceDriver": selectedDevamliArac?.isReferenceDriver
        }
        dispatch(devamliAracUpdate(saveData))
    }
    return (
    <ModalContainer onClick={()=> {dispatch(showModal(null));}}>
        <div className="modal" onClick={(e) => { e.stopPropagation(); dispatch(handleActiveSelect(null)) }}>
            <PageTopTitle isDiffPage title={"Sürücü / Araç Güncelle"}/>
            
            <div onClick={(e) =>{ e.stopPropagation(); }} className="inputs">
                <div className="row">
                    <InputSelect initialOptions={BoolData} inputWidth="100%" name="isContinueVehicle" data={selectedDevamliArac?.isContinueVehicle?.text || (selectedDevamliArac?.isContinueVehicle === true ? "Evet" : "Hayır")} setData={handleChangeContinue} labelText="Devamlı Araç mı?" />
                </div>
                <div className="row">
                    <InputSelect initialOptions={BoolData} inputWidth="100%" name="isReferenceDriver" data={selectedDevamliArac?.isReferenceDriver?.text || (selectedDevamliArac?.isReferenceDriver === true ? "Evet" : "Hayır")} setData={handleChangeReference} labelText="Bu Sürücüye Referans mısınız?" />
                </div>
                <div className="btn">
                    <Button bgColor="transparent" width="180px" handleClick={handleSave} color="#E85446">Kaydet</Button>
                    <Button bgColor="#fff" width="180px" handleClick={() => {dispatch(showModal(null)); dispatch(clearJobListWithoutGunlukAraclar())}} color="#E85446">Kapat</Button>
                    <Button bgColor="#E85446" width="180px" handleClick={() => {dispatch(showModal("DevamliAracDeleteModal"))}} color="#fff">Devamlı Araçlarımdan Kaldır</Button>
                </div>
            </div>
            
        </div>
    </ModalContainer>
  )
}

export default UpdateDevamliAracModal